import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Soodsamast

  <span style="color:#85c1dc;">**FI:**</span>
  Edullisin ensin

  <span style="color:#85c1dc;">**RU:**</span>
  Самые дешевые наверху
*/
/* @__NO_SIDE_EFFECTS__ */
const m1543 = msg(
  mf`Soodsamast`,
  mf`Edullisin ensin`,
  mf`Самые дешевые наверху`,
)

export { m1543 as 'w.saal.reasta.odavamast' }